export default "__VITE_ASSET__B4PbHJ6W__"